/* eslint-disable */
import React from 'react';

import './emp-name-card.css';

import { EmpNameCardType } from '../../../../types';

import { Image } from '../../../../../../../../../components';
import { DefaultHumanAvatar } from '../../../../../../../../../common/constants';

export function EmpNameCard({
  empName,
  profilePic,
  containerClassName,
  designation,
}: EmpNameCardType) {
  return (
    <div className={`emp-name-card ${containerClassName}`}>
      <Image
        className="emp-name-card-image"
        src={profilePic || DefaultHumanAvatar}
      />
      <div className="emp-name-card-body">
        <p className="emp-name-card-empName">{empName}</p>
        <p className="emp-name-card-designation">{designation || ''}</p>
      </div>
    </div>
  );
}
